// Joins display fields with a separator, skipping empty ones (null, '', whitespace-only), so a
// row never shows a stray leading or trailing " · " when a field is missing.
export function joinParts(parts, separator = ' · ') {
  return parts
    .map(p => (typeof p === 'string' ? p.trim() : p))
    .filter(p => p !== null && p !== undefined && p !== false && p !== '')
    .join(separator);
}
